type MinimumTimeUnit =
  | 'days'
  | 'hours'
  | 'minutes'
  | 'months'
  | 'seconds'
  | 'weeks'
  | 'years';

export const formatRelativeTime = (
  dateString: null | string | undefined,
  minimumUnit: MinimumTimeUnit = 'seconds'
): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now.getTime() - date.getTime();
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (minimumUnit === 'days' && diffInDays < 1) {
      const isToday = date.toDateString() === now.toDateString();
      return isToday ? 'Today' : 'Just now';
    }

    if (minimumUnit === 'hours' && diffInHours < 1) {
      return 'just now';
    }

    if (minimumUnit === 'minutes' && diffInMinutes < 1) {
      return 'just now';
    }

    if (minimumUnit === 'weeks' && diffInWeeks < 1) {
      if (diffInDays < 1) {
        const isToday = date.toDateString() === now.toDateString();
        return isToday ? 'today' : 'just now';
      }
      return `${diffInDays.toString()} day${diffInDays !== 1 ? 's' : ''} ago`;
    }

    if (minimumUnit === 'months' && diffInMonths < 1) {
      if (diffInDays < 1) {
        const isToday = date.toDateString() === now.toDateString();
        return isToday ? 'today' : 'just now';
      }
      if (diffInWeeks < 1) {
        return `${diffInDays.toString()} day${diffInDays !== 1 ? 's' : ''} ago`;
      }
      return `${diffInWeeks.toString()} week${diffInWeeks !== 1 ? 's' : ''} ago`;
    }

    if (minimumUnit === 'years' && diffInYears < 1) {
      if (diffInDays < 1) {
        const isToday = date.toDateString() === now.toDateString();
        return isToday ? 'today' : 'just now';
      }
      if (diffInWeeks < 1) {
        return `${diffInDays.toString()} day${diffInDays !== 1 ? 's' : ''} ago`;
      }
      if (diffInMonths < 1) {
        return `${diffInWeeks.toString()} week${diffInWeeks !== 1 ? 's' : ''} ago`;
      }
      return `${diffInMonths.toString()} month${diffInMonths !== 1 ? 's' : ''} ago`;
    }

    if (minimumUnit === 'seconds' && diffInSeconds < 60) return 'just now';
    if (minimumUnit === 'seconds' || minimumUnit === 'minutes') {
      if (diffInMinutes < 60)
        return `${diffInMinutes.toString()} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
    }
    if (
      minimumUnit === 'seconds' ||
      minimumUnit === 'minutes' ||
      minimumUnit === 'hours'
    ) {
      if (diffInHours < 24)
        return `${diffInHours.toString()} hour${diffInHours !== 1 ? 's' : ''} ago`;
    }
    if (diffInDays < 7)
      return `${diffInDays.toString()} day${diffInDays !== 1 ? 's' : ''} ago`;
    if (diffInWeeks < 4)
      return `${diffInWeeks.toString()} week${diffInWeeks !== 1 ? 's' : ''} ago`;
    if (diffInMonths < 12)
      return `${diffInMonths.toString()} month${diffInMonths !== 1 ? 's' : ''} ago`;
    return `${diffInYears.toString()} year${diffInYears !== 1 ? 's' : ''} ago`;
  } catch {
    return '';
  }
};
